import { render, staticRenderFns } from "./DropdownMenuHeader.vue?vue&type=template&id=564404c2&"
import script from "./DropdownMenuHeader.vue?vue&type=script&lang=js&"
export * from "./DropdownMenuHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports